import { render } from "./AuditTernakan.vue?vue&type=template&id=7879fa49&scoped=true"
import script from "./AuditTernakan.vue?vue&type=script&lang=js"
export * from "./AuditTernakan.vue?vue&type=script&lang=js"

import "./AuditTernakan.vue?vue&type=style&index=0&id=7879fa49&scoped=true&lang=css"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7879fa49"]])

export default __exports__